import is from '@sindresorhus/is';
import { Fragment, useContext, useState } from 'react';

import { getVisibilityStatus } from './get-visibility-status';
import { VisibilityIndicatorIcon } from './VisibilityIndicatorIcon';
import { ApplicationContext } from '../../../../shared/source/context/context';
import { useUserProfileVisibilityQuery } from '../../../../shared/source/query-hooks/profile-visibility';
import { VisibilityConfigurationDrawer } from '../pages/profile/user-profile/VisibilityConfigurationDrawer';

import type { VisibilityStatus } from './get-visibility-status';
import type { FunctionComponent } from 'react';

export const VisibilityIndicator: FunctionComponent = () => {
    const [isOpen, setIsOpen] = useState(false);
    const { applicationState } = useContext(ApplicationContext);

    const userId = applicationState.myUserProfile.get('id').unwrapOr('');

    const { data } = useUserProfileVisibilityQuery(userId);

    if (is.nullOrUndefined(data)) {
        return null;
    }
    const visibilityStatus: VisibilityStatus = getVisibilityStatus(data);

    return (
        <Fragment>
            <VisibilityIndicatorIcon visibilityStatus={visibilityStatus} onClick={() => setIsOpen(true)} />
            <VisibilityConfigurationDrawer isOpen={isOpen} onClose={() => setIsOpen(false)} />
        </Fragment>
    );
};
